import React, {useEffect, useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseRounded";
import './style.scss'
import AddIcon from "@material-ui/icons/AddRounded";
import Order from "../../../../Orders/OrdersGrid/Order/Order";

export default function ChooseOrderDialog({
                                              isOpen,
                                              isMultiple,
                                              orders,
                                              onClose,
                                              onChoose,
                                              titleText,
                                              buttonTooltipText
                                          }) {
    const [chosenOrderIds, setChosenOrderIds] = useState(new Set());

    useEffect(() => {
        const ordersIdsSet = new Set(!orders ? [] : orders.map(order => order.id));

        const newChosenOrderIds = new Set(chosenOrderIds);

        for (const chosenOrderId of newChosenOrderIds) {
            if (!ordersIdsSet.has(chosenOrderId))
                newChosenOrderIds.delete(chosenOrderId);
        }

        setChosenOrderIds(newChosenOrderIds);
    }, [orders]);

    useEffect(() => {
        if (!isOpen)
            setChosenOrderIds(new Set());
    }, [isOpen]);

    function onCloseDialog() {
        if (onClose)
            onClose();
    }

    function onChooseClick() {
        if (onChoose) {
            const chosenOrders = [...chosenOrderIds].map(chosenOrderId => orders.find(order => order.id === chosenOrderId));
            onChoose(chosenOrders);
        }
    }

    function onOrderClick(orderId) {
        const newChosenOrderIds = new Set(chosenOrderIds);

        if (newChosenOrderIds.has(orderId))
            newChosenOrderIds.delete(orderId)
        else {
            if (!isMultiple && newChosenOrderIds.size > 0)
                newChosenOrderIds.clear()

            newChosenOrderIds.add(orderId)
        }

        setChosenOrderIds(newChosenOrderIds);
    }

    return (
        <Dialog className="choose-order-dialog"
                open={isOpen}
                onClose={onCloseDialog}
                PaperProps={{className: "choose-order-dialog-paper"}}>
                <DialogTitle id="draggable-sent-dialog-title">
                    <div>
                        {titleText}
                    </div>
                </DialogTitle>
                <DialogContent dividers={true}
                               className="dialog-content">
                    {
                        orders.length > 0 ?
                            orders.map(order => (
                                <div key={`choose-order-${order.id}`}
                                     className={chosenOrderIds.has(order.id) ? "chosen-order" : "not-chosen-order"}>
                                    <Order id={`order-${order.id}`}
                                           order={order}
                                           allowEdit={false}
                                           onClick={() => onOrderClick(order.id)}
                                    />
                                </div>
                            ))
                            :
                            <div className="no-orders-text">
                                אין הזמנות
                            </div>
                    }
                </DialogContent>
                <DialogActions className="dialog-actions">
                    <IconButton className="close-button"
                                onClick={onCloseDialog}>
                        <CloseIcon fontSize="medium"/>
                    </IconButton>
                    <Tooltip disableFocusListener={true} arrow
                             enterTouchDelay={0}
                             title={(chosenOrderIds.size === 0) ? "אנא בחר הזמנה" : buttonTooltipText}>
                    <span>
                        <IconButton
                            className={"choose-button" + (chosenOrderIds.size === 0 ? " choose-button-disabled" : "")}
                            disabled={chosenOrderIds.size === 0}
                            onClick={onChooseClick}>
                            <AddIcon/>
                        </IconButton>
                    </span>
                    </Tooltip>
                </DialogActions>
        </Dialog>
    );
}